import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import ImagesColumn from '../image-display/ImagesColumn';

class Gallery extends Component {

	cols: any[] = [];

	constructor(props) {
		super(props);

		this.loadMorePhotos = this.loadMorePhotos.bind(this);
		this.loadingPhotos = false;

		this.state = {
			favoredPhotos: []
		};

		this.props.router.setRouteLeaveHook(
      		this.props.route,
      		this.closeModalBeforeLeaving.bind(this)
    	);		

	}

	componentWillMount() {
		if (this.props.photos.length === 0) {
			alert('Please search for photos before going to the gallery page.');
			browserHistory.push('/search');
		}		
		this.props.initializeFavorites();
		this.setState({
			favoredPhotos: this.props.favoredPhotos
		});
	}

	componentDidMount() {
		this.props.dispatchAdjustUI();
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			favoredPhotos: nextProps.favoredPhotos
		});

		if (nextProps.currentPage && nextProps.currentPage > 1 && nextProps.currentPage > this.props.currentPage) {
			window.addEventListener(
				'doneLoadingImages', 
				() => {
					if (this.loadingPhotos) {
						this.loadingPhotos = false; 
						this.forceUpdate();
					}
				}, 
				{
					once: true
				}
			);
			this.props.dispatchAdjustUI();
		}
	}

	closeModalBeforeLeaving() {
		this.props.dispatchCloseModal();
		this.props.dispatchCompletedAdjustUI();
	}

	loadMorePhotos() {
		if (this.loadingPhotos) return;
		this.loadingPhotos = true;
		this.forceUpdate();
		this.props.loadMorePhotos(this.props.searchQuery, this.props.currentPage + 1);
	}

	render() {	
		return (
			<div id="main-content-container">
				<div className="title">Showing {this.props.photos.length} results ({this.props.searchQuery}): </div>
				<div className="container-fluid">
					<div className="row">
						{this.props.picCols.map((colNum, index) => 
							<div key={index.toString()} id={'container'+colNum} className={"container col-md-4 col-sm-6 col-xs-12 " + (this.props.currentPage < this.props.totalPages ? 'container-padding-btm' : '')}>
								<ImagesColumn colNum={index} totalCols={this.props.picCols} photos={this.props.photos} favoredPhotos={this.state.favoredPhotos}></ImagesColumn>
						</div>)}
						{this.props.currentPage < this.props.totalPages && <div className="load-more-photos-container" onClick={this.loadMorePhotos}>	
							{!this.loadingPhotos && <div className="load-more-photos-banner"><div>Page {this.props.currentPage} of {this.props.totalPages}</div><div>Load more photos...</div></div>}
							{this.loadingPhotos && <img src="/react-redux-photos-app/ico_loading.gif" role="presentation"></img>}
						</div>}
					</div>
				</div>
			</div>
		)
	}

}

export default Gallery;



/** WEBPACK FOOTER **
 ** ./src/gallery/Gallery.js
 **/